
import {
  Component, InjectReactive, Prop, Provide, Vue,
} from 'nuxt-property-decorator'

@Component({
  name: 'TabAccordionElement',
  components: {
    BaseTabElement: () => import('../base/tab/BaseTabElement.vue'),
    BaseAccordionElement: () => import('../base/accordion/BaseAccordionElement.vue'),
  },
})

export default class TabAccordionElement extends Vue {
  @Prop() open ?: boolean

  @Prop() title ?: string

  @Provide('ignoreGridSizeUseWidthFull') ignoreGridSizeUseWidthFull : boolean = true

  @InjectReactive('accordion') isAccordion! : boolean
}
